import { GDRLogo } from "./gdr-logo";
import { cn } from "#app/utils/misc.tsx";

type CtaProps = {
    heading: string;
    backgroundStyle?: keyof typeof ctaColorMap;
    children?: React.ReactNode;
}

const ctaColorMap = {
    default: 'bg-background text-foreground',
    muted: 'bg-muted text-foreground',
    primary: 'bg-primary text-primary-foreground',
    secondary: 'bg-secondary text-secondary-foreground',
    accent: 'bg-accent text-accent-foreground',
}

const logoColorMap = {
    default: 'text-muted',
    muted: 'text-background',
    primary: 'text-muted-foreground',
    accent: 'text-muted-accent',
    secondary: 'text-muted-foreground',
}

export default function Cta({ heading, backgroundStyle = "default", children }: CtaProps) {

    return (
        <div className="container mb-24 sm:mb-32">
            <div className={cn(
                "mx-auto relative isolate overflow-hidden rounded-md px-6 py-16 lg:flex lg:items-center lg:justify-between lg:px-8",
                ctaColorMap[backgroundStyle],
            )}>
                <GDRLogo className={cn('absolute bottom-0 right-0 -z-10', logoColorMap[backgroundStyle])} />
                {heading && (
                <h2 className="max-w-2xl text-5xl font-semibold tracking-tight sm:text-6xl">
                    {heading}
                </h2>)}
                <div className="mt-10 flex flex-col justify-center gap-6 lg:mt-0 lg:shrink-0">
                    {children}
                </div>
            </div>
        </div>
    )
}